export enum DashboardFilterCategory {
	HIERARCHY = 'HIERARCHY',
	TEXT = 'TEXT',
	DASHBOARD_DRILL = 'DASHBOARD_DRILL',
	DATE_RANGE = 'DATE_RANGE',
	ATTRIBUTE = 'ATTRIBUTE',
	TOPIC = 'TOPIC',
	SAVED_FILTER = 'SAVED_FILTER',
}
